/** Colour themes; their names live in the message catalogue (`themes`). */
export const THEMES = [
	{
		id: 'solskin',
		bg: '#FFF1C9',
		surface: '#FFFFFF',
		ink: '#1B1A17',
		primary: '#FF5A36',
		accent: '#2DB36F',
		tile: '#A58BFF'
	},
	{
		id: 'slik',
		bg: '#FFEFF6',
		surface: '#FFFFFF',
		ink: '#3A1838',
		primary: '#D6246E',
		accent: '#0FA89A',
		tile: '#B9A2FF'
	},
	{
		id: 'aften',
		bg: '#1D1531',
		surface: '#2A2045',
		ink: '#FFF6E9',
		primary: '#FFC53D',
		accent: '#5EE6B0',
		tile: '#8CA8FF'
	},
	{
		id: 'have',
		bg: '#E6F2DC',
		surface: '#FFFFFF',
		ink: '#17301E',
		primary: '#2F8F4E',
		accent: '#F28C28',
		tile: '#5FC3A8'
	},
	{
		id: 'hav',
		bg: '#E3F1FB',
		surface: '#FFFFFF',
		ink: '#0F2A44',
		primary: '#1F6FD1',
		accent: '#FF7A59',
		tile: '#A9B8FF'
	},
	{
		id: 'lakrids',
		bg: '#141414',
		surface: '#1F1F1F',
		ink: '#F5F2EA',
		primary: '#FF4F8B',
		accent: '#B6F24A',
		tile: '#5CC8FF'
	}
] as const;

export type ThemeId = (typeof THEMES)[number]['id'];

const STORAGE_KEY = 'madplan-theme';

/** The colour theme is a per-device preference, so it lives in localStorage, not the database. */
class ThemeState {
	current = $state<ThemeId>(readStoredTheme());

	set(id: ThemeId) {
		this.current = id;
		try {
			localStorage.setItem(STORAGE_KEY, id);
		} catch {
			// Private mode or blocked storage: the theme still applies for this session.
		}
		applyTheme(id);
	}
}

function readStoredTheme(): ThemeId {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		return THEMES.some((t) => t.id === stored) ? (stored as ThemeId) : 'solskin';
	} catch {
		return 'solskin';
	}
}

export function applyTheme(id: ThemeId) {
	document.documentElement.dataset.theme = id;
	const primary = THEMES.find((t) => t.id === id)?.primary;
	document.querySelector('meta[name="theme-color"]')?.setAttribute('content', primary ?? '#FF5A36');
}

export const theme = new ThemeState();
